import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Sparkles } from "lucide-react";
interface ClaimChipProps {
  authorSlug: string;
  variant?: "inline" | "banner";
  className?: string;
}
export function ClaimChip(t0) {
  const $ = _c(9);
  const {
    authorSlug,
    variant: t1,
    className: t2
  } = t0;
  const variant = t1 === undefined ? "inline" : t1;
  const className = t2 === undefined ? "" : t2;
  if (variant === "banner") {
    const t3 = `/claim/${authorSlug}`;
    const t4 = `group flex items-center justify-between gap-4 rounded-xl border border-primary/30 bg-primary/5 px-4 py-3 transition-colors hover:bg-primary/10 ${className}`;
    let t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex items-center gap-3"><span className="flex size-9 items-center justify-center rounded-full bg-primary/15 text-primary"><Sparkles className="size-4" /></span><div><p className="text-sm font-medium text-foreground">Is this your work?</p><p className="text-xs text-muted-foreground">This profile hasn't been claimed. See stats and start earning.</p></div></div>;
      t6 = <span className="text-xs font-medium text-primary group-hover:underline">Claim profile →</span>;
      $[0] = t5;
      $[1] = t6;
    } else {
      t5 = $[0];
      t6 = $[1];
    }
    let t7;
    if ($[2] !== t3 || $[3] !== t4) {
      t7 = <Link href={t3} className={t4}>{t5}{t6}</Link>;
      $[2] = t3;
      $[3] = t4;
      $[4] = t7;
    } else {
      t7 = $[4];
    }
    return t7;
  }
  const t3 = `/claim/${authorSlug}`;
  const t4 = `inline-flex items-center gap-1 rounded-full border border-primary/30 bg-primary/10 px-2 py-0.5 text-[10px] font-medium text-primary transition-colors hover:bg-primary/20 ${className}`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Sparkles className="size-3" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4) {
    t6 = <Link href={t3} className={t4}>{t5}Is this yours?</Link>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}